import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetITMultiApprovalError,
  resetITMultiRejectApprovalData,
} from "../../../redux/features/internalTransaction/internalTransactionSingleApproval";

import formatDateViewAll from "../../../utils/formatDateViewAll";
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import AccountNumberWithBank from "../../_utils/CommonViewAllCard/CardSubComponent/AccountNumberWithBank";
import TextWithCTA from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA";
import TextWithIcon from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import "./index.css";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const InternalTxnMultiApproval = ({
  filterOpen,
  data,
  setselectAllCard,
  selectedTransactions,
  setSelectedTransactions,
  setTotalAmount,
  setSelectedSendTransactions,
  selectedSendTransactions,
  setTxnId,
  openMultiTxnDetailModal,
  SetInternalAccountid,
  internalAccDetailOpen,
  setInternalAccDetailOpen,
  filterRef,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [accountData, setAccountData] = useState([]);
  const { beneTxnAccountData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );
  const services = useSelector((state) => state.refreshToken.services);

  const lengthVarForConditonTwenty = 20;

  const { internalTxnMultiApprovalError, internalTxnMultiRejectApprovalError } =
    useSelector((state) => state.internalTxnSingleApproval);

  useEffect(() => {
    dispatch(resetITMultiApprovalError());
    dispatch(resetITMultiRejectApprovalData());
  }, [internalTxnMultiApprovalError, internalTxnMultiRejectApprovalError]);

  useEffect(() => {
    setAccountData({
      ...accountData,
      owner_account_balance_last_fetched_at_in_words:
        beneTxnAccountData?.transaction[0]
          ?.owner_account_balance_last_fetched_at_in_words,
      owner_account_balance:
        beneTxnAccountData?.transaction[0]?.owner_account_balance,
      owner_account_balance_last_fetched_at:
        beneTxnAccountData?.transaction[0]
          ?.owner_account_balance_last_fetched_at,
    });
  }, [beneTxnAccountData]);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--settled)";
      case "denied":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--settled)";
    }
  };

  const SideDrawerOpen = async (id, txnId) => {
    SetInternalAccountid(id);
    setInternalAccDetailOpen(!internalAccDetailOpen);
  };

  const handleCardClick = (transaction) => {
    if (transaction?.internal_account_approval_status === "approved") {
      setselectAllCard(false);
      setSelectedTransactions((prevSelected) => {
        const cardAmount = Number(transaction?.amount);
        const isSelected = prevSelected.includes(transaction?.txn_id);

        if (isSelected) {
          setTotalAmount((prevAmount) => prevAmount - cardAmount);
          let data = selectedSendTransactions.filter((val) => {
            return val?.txn_id !== transaction?.txn_id;
          });
          setSelectedSendTransactions(data);
          return prevSelected.filter((id) => id !== transaction?.txn_id);
        } else {
          if (prevSelected.length < lengthVarForConditonTwenty) {
            setTotalAmount((prevAmount) => prevAmount + cardAmount);
            setSelectedSendTransactions((prev) => [...prev, transaction]);
            return [...prevSelected, transaction?.txn_id];
          } else {
            return prevSelected;
          }
        }
      });
    }
  };

  return (
    <>
      <div
        className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md ${filterOpen && "pointer-events-none"}`}
      >
        {data?.map((transaction) => {
          return (
            <CardContainer
              filterRef={filterRef}
              hoverHeight={
                GlobalConfiguration?.internalTxnMultiApprovalCardHoverHeight
              }
              isDisabled={
                filterOpen ||
                transaction.internal_account_approval_status === "pending"
                  ? true
                  : false
              }
              key={transaction?.txn_id}
              isSelected={selectedTransactions.includes(transaction.txn_id)}
              onClickHandler={(e) => {
                if (
                  transaction?.internal_account_approval_status === "pending"
                ) {
                  SideDrawerOpen(
                    transaction?.internal_account_id,
                    transaction?.txn_id,
                  );
                } else {
                  handleCardClick(transaction);
                }
              }}
            >
              <card-body>
                <TextWithIcon
                  type={
                    transaction.internal_account_approval_status === "pending"
                      ? "Text"
                      : "Amount"
                  }
                  fontWeight={"semibold"}
                  text={
                    transaction.internal_account_approval_status === "pending"
                      ? "Account approval pending"
                      : transaction?.amount
                  }
                  subText="Transaction amount"
                  textColor={getStatusColor(
                    transaction.internal_account_approval_status,
                  )}
                  iconComponentArray={
                    transaction.internal_account_approval_status !== "pending"
                      ? [
                          ...(transaction?.confidential_transaction === "Y"
                            ? [
                                {
                                  icon: "https://q2pay.in/new_assets/common/detail_page/confidential_transaction.svg",
                                  title: "confidential",
                                  isDisabled: false,
                                },
                              ]
                            : []),

                          {
                            icon: selectedTransactions.includes(
                              transaction?.txn_id,
                            )
                              ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                              : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg",
                            isDisabled: false,
                          },
                        ]
                      : []
                  }
                />
                <AccountNumberWithBank
                  sourceAccNo={transaction?.owner_account_bank_acc_no}
                  destinationAccNo={transaction?.internal_account_bank_acc_no}
                  destinationIfsc={transaction?.internal_account_ifsc_code}
                  sourceIfsc={transaction?.owner_account_ifsc_code}
                />
                <TextWithCTA
                  btnText={
                    transaction.internal_account_approval_status === "pending"
                      ? "Approve account"
                      : "Additional details"
                  }
                  enabledBgColor={"var(--text-primary)"}
                  enabledTextColor={"var(--primary-bg)"}
                  handleFunction={(e) => {
                    e.stopPropagation();
                    setAccountData(transaction);
                    if (!sessionStorage?.getItem("q2p_token")) {
                      setInternalAccDetailOpen(false);

                      return;
                    }
                    if (
                      transaction?.internal_account_approval_status ===
                      "pending"
                    ) {
                      if (
                        (services?.includes("IVAccount") &&
                          services?.includes("IAAccount")) ||
                        services?.includes("Admin")
                      ) {
                        SideDrawerOpen(
                          transaction?.internal_account_id,
                          transaction?.txn_id,
                        );
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "IAAccount, IVAccount, Admin",
                          },
                        });
                      }
                      return;
                    }
                    if (
                      (services?.includes("IVAccount") &&
                        services?.includes("IAAccount")) ||
                      services?.includes("Admin")
                    ) {
                      openMultiTxnDetailModal();
                      setTxnId(transaction?.txn_id);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "IAAccount, IVAccount, Admin",
                        },
                      });
                    }
                  }}
                  icon={
                    "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                  }
                  isDisabled={
                    !(
                      transaction?.internal_account_approval_status ===
                        "pending" ||
                      transaction?.internal_account_approval_status ===
                        "approved"
                    )
                  }
                  text={
                    transaction.created_on
                      ? formatDateViewAll(transaction.created_on, false, false)
                      : "Not given"
                  }
                  subText="Date"
                />
              </card-body>
              <card-hover>
                <TextWithIcon
                  text={transaction?.labels?.join(", ") || "No labels assigned"}
                  fontWeight={"normal"}
                  textColor={"var(--text-primary)"}
                  iconComponentArray={[
                    {
                      icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                    },
                  ]}
                />
              </card-hover>
            </CardContainer>
          );
        })}
      </div>
    </>
  );
};

export default InternalTxnMultiApproval;
